import React from 'react';
import { withStyles, withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';

// modules
import moment from 'moment';

// ui/ux
import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TextField from '@material-ui/core/TextField';

// icons
import DeleteIcon from '@material-ui/icons/Delete';

// ours
import { uuidv4 } from '../../common';

const TABLE_STRUCT = [
  {
    name: 'Level 0',
    id: 'c'
  },
  {
    name: 'Level 1',
    id: 'p'
  },
  {
    name: 'Hasc Code',
    id: 'g'
  },
  {
    name: '',
    id: 'actions'
  }
];

const styles = (theme) => ({
  textfield: {
    color: 'white !important',
    '& .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.text.secondary
    },
    '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: theme.palette.text.secondary
    }
  }
});

class AnchorGeoTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sortOrder: 'asc',
      sortColumn: 'g',
      id: uuidv4(),
      inputValue: '',
      options: []
    };

    this.onOpen = this.onOpen.bind(this);
    this.onClose = this.onClose.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  onOpen() {}
  onClose() {}
  onSelect(_, v) {
    this.setState({
      inputValue: ''
    });
    this.props.onSelect && this.props.onSelect(v.hasc);
  }
  onChange(e) {
    const { value: v } = e.target;
    this.setState((s) => ({
      inputValue: v,
      options: v.length > 0 ? s.options : []
    }));

    v.length > 0 &&
      this.props.onChange &&
      this.props.onChange(v, (options) => {
        this.setState({ options });
      });
  }

  render() {
    const { sortOrder, sortColumn, id, loading, inputValue, options } = this.state;
    const { classes, filterText, geographies, onSelect, onChange, onDelete } = this.props;

    const filterTextLower = filterText ? filterText.toLowerCase() : null;
    let sortedGeos = geographies.sort((a, b) => {
      a = a[sortColumn];
      b = b[sortColumn];

      if (sortColumn.endsWith('_at')) {
        a = moment(a);
        b = moment(b);
        if (a === b) return 0;
        if (a > b) {
          return sortOrder === 'asc' ? 1 : -1;
        } else {
          return sortOrder === 'asc' ? -1 : 1;
        }
      } else if (typeof a === 'string') {
        return sortOrder === 'asc' ? a.localeCompare(b) : b.localeCompare(a);
      } else if (typeof a === 'number') {
        if (a === b) return 0;
        if (a > b) {
          return sortOrder === 'asc' ? 1 : -1;
        } else {
          return sortOrder === 'asc' ? -1 : 1;
        }
      } else {
        return 0;
      }
    });

    if (filterText && filterText.length > 0) {
      sortedGeos = sortedGeos.filter((d) => {
        return Object.values(d).join(' ').toLowerCase().includes(filterTextLower);
      });
    }

    const acProps = [!!onSelect, !!onChange].filter((d) => d).length;
    if (acProps > 0 && acProps !== 2) {
      throw new Error('component misconfigured, all 3 props required: onSelect,onChange');
    }
    return (
      <Box>
        {acProps === 2 ? (
          <Autocomplete
            getOptionLabel={(option) => option.name}
            inputValue={inputValue}
            value={null}
            disableClearable
            id={id}
            options={options}
            onChange={this.onSelect}
            onOpen={this.onOpen}
            onClose={this.onClose}
            renderInput={(params) => (
              <TextField
                onChange={this.onChange}
                {...params}
                label={'Find & Add Geographies'}
                placeholder={'US.VA'}
                variant="outlined"
                className={classes.textfield}
                InputProps={{
                  ...params.InputProps,
                  endAdornment: (
                    <React.Fragment>
                      {loading ? <CircularProgress color="inherit" size={20} /> : null}
                      {params.InputProps.endAdornment}
                    </React.Fragment>
                  )
                }}
              />
            )}
          />
        ) : null}

        <TableContainer>
          <Table className={'noselect'}>
            <TableHead>
              <TableRow>
                {TABLE_STRUCT.map((d) => {
                  return (
                    <TableCell align="center" key={d.id}>
                      <TableSortLabel
                        active={sortColumn === d.id}
                        direction={sortOrder}
                        onClick={() => {
                          if (sortColumn === d.id) {
                            return this.setState({
                              sortOrder: sortOrder === 'asc' ? 'desc' : 'asc'
                            });
                          }
                          this.setState({
                            sortColumn: d.id
                          });
                        }}
                      >
                        {d.name}
                      </TableSortLabel>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedGeos.map((row) => (
                <TableRow
                  key={row.g}
                  hover
                  // className={classes.row}
                  // onClick={() => {
                  //   onFormSelect && onFormSelect(row);
                  // }}
                >
                  {TABLE_STRUCT.map((d, i) => {
                    const k = d.id;
                    const m = d.rowMutation;
                    const v = row[k];
                    return (
                      <TableCell key={k} align="center" title={v} component={i === 0 ? 'th' : null} scope={i === 0 ? 'row' : null}>
                        {onDelete && k === 'actions' ? (
                          <IconButton onClick={() => onDelete(row['g'])}>
                            <DeleteIcon />
                          </IconButton>
                        ) : m && v ? (
                          m(v)
                        ) : (
                          v
                        )}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }
}

AnchorGeoTable.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  geographies: PropTypes.array.isRequired,
  filterText: PropTypes.string,
  onChange: PropTypes.func,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func
};
AnchorGeoTable.defaultProps = {};

export default withTheme(withStyles(styles)(AnchorGeoTable));
